import {gql} from '@apollo/client'

// ---------------------------------------------------------------------------
// Course
// ---------------------------------------------------------------------------

export const CREATE_COURSE = gql`
  mutation createCourse($courseData: course_input!) {
    createCourse(courseData: $courseData) {
      success
      course {
        id
        name
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_COURSE = gql`
  mutation updateCourse($id: Int!, $courseData: course_input!) {
    updateCourse(id: $id, courseData: $courseData) {
      success
      course {
        id
        name
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_COURSE = gql`
  mutation deleteCourse($id: Int!) {
    deleteCourse(id: $id) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

// ---------------------------------------------------------------------------
// Lesson
// ---------------------------------------------------------------------------

export const CREATE_LESSON = gql`
  mutation createLesson($lessonData: lesson_input!) {
    createLesson(lessonData: $lessonData) {
      success
      lesson {
        id
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_LESSON = gql`
  mutation updateLesson($id: Int!, $lessonData: lesson_input!) {
    updateLesson(id: $id, lessonData: $lessonData) {
      success
      lesson {
        id
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_LESSON = gql`
  mutation deleteLesson($id: Int!) {
    deleteLesson(id: $id) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const REORDER_LESSONS = gql`
  mutation reorderLessons($courseId: Int!, $orderedLessonIds: [Int]!) {
    reorderLessons(courseId: $courseId, orderedLessonIds: $orderedLessonIds) {
      success
      errors {
        field
        message
      }
    }
  }
`

// ---------------------------------------------------------------------------
// Quiz / Question / AnswerOption
// ---------------------------------------------------------------------------

export const CREATE_QUIZ = gql`
  mutation createQuiz($quizData: quiz_input!) {
    createQuiz(quizData: $quizData) {
      success
      quiz {
        id
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_QUIZ = gql`
  mutation updateQuiz($id: Int!, $title: String, $passingScorePercentage: Int) {
    updateQuiz(id: $id, title: $title, passingScorePercentage: $passingScorePercentage) {
      success
      quiz {
        id
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_QUIZ = gql`
  mutation deleteQuiz($id: Int!) {
    deleteQuiz(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const CREATE_QUESTION = gql`
  mutation createQuestion($questionData: question_input!) {
    createQuestion(questionData: $questionData) {
      success
      question {
        id
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_QUESTION = gql`
  mutation updateQuestion($id: Int!, $text: String, $questionType: String, $order: Int) {
    updateQuestion(id: $id, text: $text, questionType: $questionType, order: $order) {
      success
      question {
        id
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_QUESTION = gql`
  mutation deleteQuestion($id: Int!) {
    deleteQuestion(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const CREATE_ANSWER_OPTION = gql`
  mutation createAnswerOption($optionData: answer_option_input!) {
    createAnswerOption(optionData: $optionData) {
      success
      option {
        id
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_ANSWER_OPTION = gql`
  mutation updateAnswerOption($id: Int!, $text: String, $isCorrect: Boolean, $order: Int) {
    updateAnswerOption(id: $id, text: $text, isCorrect: $isCorrect, order: $order) {
      success
      option {
        id
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_ANSWER_OPTION = gql`
  mutation deleteAnswerOption($id: Int!) {
    deleteAnswerOption(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

// ---------------------------------------------------------------------------
// Learner-facing
// ---------------------------------------------------------------------------

export const MARK_LESSON_COMPLETE = gql`
  mutation markLessonComplete($lessonId: Int!) {
    markLessonComplete(lessonId: $lessonId) {
      success
      progress {
        id
        status
        completedAt
      }
      courseCompletionPercentage
      errors {
        field
        message
      }
    }
  }
`

export const SUBMIT_QUIZ_ATTEMPT = gql`
  mutation submitQuizAttempt($quizId: Int!, $answers: JSONString!) {
    submitQuizAttempt(quizId: $quizId, answers: $answers) {
      success
      attempt {
        id
        scorePercentage
        passed
        submittedAt
      }
      correctAnswers
      errors {
        field
        message
      }
    }
  }
`
